.spacer{display:block;height:42px}swiper-container{z-index:0!important}swiper-container::part(bullet-active){background-color:#0099a8}
/*# sourceMappingURL=candidates-carousel.component-VRZZPJLL.css.map */
